import Vue from 'vue'
import Router from 'vue-router'
let domain=localStorage.getItem('domain')
Vue.use(Router)
let title = '云玺量子云智能印签管控平台--'
let str="/:orgId"
export default new Router({
	mode: 'history',
	// base:'/aaa/',
	routes: [
		{
			path: str+'/',
			name: 'home',
			redirect: str+'/index',
		},
		{
			path: '/index',
			name: 'home2',
			redirect: domain? `/${domain}/index`:'/yxkj/index',
		},
		{
		path: '/',
		name: 'Home',
		redirect: domain? `/${domain}/index`:'/yxkj/index',
		meta: {
			key: 2,
			title: '首页',
			networkTitle: title + '首页',
			requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			keepAlive: true //缓存组件
		},
		component: () => import('@/views/home/index'),
		children: [{
			path: str+'/index',
			meta: {
				key: 2,
				title: '首页',
				networkTitle: title + '首页',
				requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				keepAlive: true //缓存组件
			},
			name: 'index',
			component: () => import('@/views/home/index/index')
		},
		{
			path: str+'/myPanel',
			meta: {
				key: 2,
				title: '我的面板',
				keepAlive: true //缓存组件
			},
			name: 'myPanel',
			component: () => import('@/views/home/myPanel/myPanel'),
			children: [{
				path: str+'/myInfo',
				meta: {
					key: 2,
					parent_name: '我的面板', //添加父级的名字属于印章下的
					networkTitle: title + '个人信息',
					title: '个人信息',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'myInfo',
				component: () => import('@/views/home/myPanel/myInfo/myInfo')
			}, {
				path: str+'/changePassword',
				meta: {
					key: 2,
					parent_name: '我的面板', //添加父级的名字属于印章下的
					networkTitle: title + '修改密码',
					title: '修改密码',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'changePassword',
				component: () => import(
					'@/views/home/myPanel/changePassword/changePassword')
			},
			{
				path: str+'/systemMessage',
				meta: {
					key: 2,
					parent_name: '我的面板', //添加父级的名字属于印章下的
					networkTitle: title + '系统消息',
					title: '系统消息',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'systemMessage',
				component: () => import(
					'@/views/home/myPanel/systemMessage/systemMessage')
			}, {
				path: str+'/myApplication',
				meta: {
					key: 2,
					parent_name: '我的面板', //添加父级的名字属于印章下的
					networkTitle: title + '我的申请',
					title: '我的申请',
					requireAuth: false, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'myApplication',
				component: () => import(
					'@/views/home/myPanel/myApplication/myApplication')
			}
			]
		},
		{
			path: str+'/deviceManagement',
			redirect:str+'/sealManagement',
			meta: {
				key: 2,
				networkTitle: title + '设备管理',
				title: '设备管理',
				keepAlive: false //缓存组件
			},
			name: 'deviceManagement',
			component: () => import('@/views/home/deviceManagement/deviceManagement'),
			children: [{
				path: str+'/sealManagement',
				meta: {
					key: 2,
					parent_name: '设备管理', //添加父级的名字属于印章下的
					networkTitle: title + '印章管理',
					title: '印章管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'sealManagement',
				component: () => import(
					'@/views/home/deviceManagement/sealManagement/sealManagement')
			},
			{
				path: str+'/cupboardManagement',
				meta: {
					key: 2,
					parent_name: '设备管理', //添加父级的名字属于印章下的
					networkTitle: title + '印章柜管理',
					title: '印章柜管理',
					requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false//缓存组件
				},
				name: 'cupboardManagement',
				component: () => import('@/views/home/deviceManagement/cupboardManagement/cupboardManagement')
			},
      {
      	path: str+'/accessControl',
      	meta: {
      		key: 2,
      		parent_name: '设备管理', //添加父级的名字属于印章下的
      		networkTitle: title + '门禁管理',
      		title: '门禁管理',
      		requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
      		keepAlive: false//缓存组件
      	},
      	name: 'accessControl',
      	component: () => import('@/views/home/deviceManagement/accessControl/accessControl')
      },
			{
				path: str+'/printConsoleManagement',
				meta: {
					key: 2,
					parent_name: '设备管理', //添加父级的名字属于印章下的
					networkTitle: title + '印控台管理',
					title: '印控台管理',
					requireAuth: true,// 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false//缓存组件
				},
				name: 'printConsoleManagement',
				component: () => import('@/views/home/deviceManagement/printConsoleManagement/printConsoleManagement')
			}]
		},
		{
			path: str+'/organizationalStructure',
			redirect:str+'/companyManagement',
			meta: {
				key: 2,
				networkTitle: title + '组织架构',
				title: '组织架构',
				keepAlive: false //缓存组件
			},
			name: 'organizationalStructure',
			component: () => import(
				'@/views/home/organizationalStructure/organizationalStructure'),
			children: [{
				path: str+'/companyManagement',
				meta: {
					key: 2,
					parent_name: '组织架构', //添加父级的名字属于印章下的
					networkTitle: title + '组织管理',
					title: '组织管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'companyManagement',
				component: () => import(
					'@/views/home/organizationalStructure/companyManagement/companyManagement'
				)
			}, {
				path: str+'/jobManagement',
				meta: {
					key: 2,
					parent_name: '组织架构', //添加父级的名字属于印章下的
					networkTitle: title + '职位管理',
					title: '职位管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'jobManagement',
				component: () => import(
					'@/views/home/organizationalStructure/jobManagement/jobManagement'
				)
			}, {
				path: str+'/privilegeManagement',
				meta: {
					key: 2,
					parent_name: '组织架构', //添加父级的名字属于印章下的
					networkTitle: title + '部门管理',
					title: '部门管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'privilegeManagement',
				component: () => import(
					'@/views/home/organizationalStructure/privilegeManagement/privilegeManagement'
				)
			}, {
				path: str+'/roleManagement',
				meta: {
					key: 2,
					parent_name: '组织架构', //添加父级的名字属于印章下的
					networkTitle: title + '角色管理',
					title: '角色管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'roleManagement',
				component: () => import(
					'@/views/home/organizationalStructure/roleManagement/roleManagement'
				)
			}, {
				path: str+'/personnelManagement',
				meta: {
					key: 2,
					parent_name: '组织架构', //添加父级的名字属于印章下的
					networkTitle: title + '人员管理',
					title: '人员管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'personnelManagement',
				component: () => import(
					'@/views/home/organizationalStructure/personnelManagement/personnelManagement'
				)
			}]
		},
		{
			path: str+'/platformManagement',
			redirect:str+'/systemPrivilegeManagement',
			meta: {
				key: 2,
				networkTitle: title + '平台管理',
				title: '平台管理',
				keepAlive: false //缓存组件
			},
			name: 'platformManagement',
			component: () => import('@/views/home/platformManagement/platformManagement'),
			children: [{
				path: str+'/systemPrivilegeManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '系统权限管理',
					title: '系统权限管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'systemPrivilegeManagement',
				component: () => import(
					'@/views/home/platformManagement/systemPrivilegeManagement/systemPrivilegeManagement'
				)
			},
			{
				path: str+'/serverManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '服务功能管理',
					title: '服务功能管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'serverManagement',
				component: () => import(
					'@/views/home/platformManagement/serverManagement/serverManagement'
				)
			},
			{
				path: str+'/smsNoticeSet',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '短信通知设置',
					title: '短信通知设置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'smsNoticeSet',
				component: () => import(
					'@/views/home/platformManagement/smsNoticeSet/smsNoticeSet')
			},
			{
				path: str+'/QuantumManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '量子传输设置',
					title: '量子传输设置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'QuantumManagement',
				component: () => import(
					'@/views/home/platformManagement/QuantumManagement/QuantumManagement'
				)
			},
			{
				path: str+'/sealConfiguration',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '印章配置设置',
					title: '印章配置设置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'sealConfiguration',
				component: () => import(
					'@/views/home/platformManagement/sealConfiguration/sealConfiguration'
				)
			},
			{
				path: str+'/cabinetConfiguration',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '印章柜配置管理',
					title: '印章柜配置管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'cabinetConfiguration',
				component: () => import(
					'@/views/home/platformManagement/cabinetConfiguration/cabinetConfiguration'
				)
			},
			{
				path: str+'/logHistoryManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '日志历史',
					title: '日志历史',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'logHistoryManagement',
				component: () => import(
					'@/views/home/platformManagement/logHistoryManagement/logHistoryManagement'
				)
			},
			{
				path: str+'/appUpdate',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + 'app更新设置',
					title: 'app更新设置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'appUpdate',
				component: () => import(
					'@/views/home/platformManagement/appUpdate/appUpdate')
			},
      {
      	path: str+'/tenantManagement',
      	meta: {
      		key: 2,
      		parent_name: '平台管理', //添加父级的名字属于印章下的
      		networkTitle: title + '租户管理',
      		title: '租户管理',
      		requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      		keepAlive: false //缓存组件
      	},
        name: 'tenantManagement',
        	component: () => import(
        		'@/views/home/platformManagement/tenantManagement/tenantManagement')
        },
			{
				path: str+'/pluginConfigurationManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '插件配置管理',
					title: '插件配置管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'pluginConfigurationManagement ',
				component: () => import(
					'@/views/home/platformManagement/pluginConfigurationManagement/pluginConfigurationManagement'
				)
			},
			{
				path: str+'/exceptionInfoCapture',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '异常信息捕获',
					title: '异常信息捕获',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'exceptionInfoCapture',
				component: () => import(
					'@/views/home/platformManagement/exceptionInfoCapture/exceptionInfoCapture'
				)
			},
			{
				path: str+'/relocationRecord',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '迁章记录',
					title: '迁章记录',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'relocationRecord',
				component: () => import(
					'@/views/home/platformManagement/relocationRecord/relocationRecord'
				)
			},
			{
				path: str+'/updateLog',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '更新日志',
					title: '更新日志',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'updateLog',
				component: () => import(
					'@/views/home/platformManagement/updateLog/updateLog')
			},
			{
				path: str+'/runLog',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '运行日志',
					title: '运行日志',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'runLog',
				component: () => import(
					'@/views/home/platformManagement/runLog/runLog')
			},
			{
				path: str+'/ExcelSealEdit',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + 'Excel导入/编辑',
					title: 'Excel导入/编辑',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'ExcelSealEdit',
				component: () => import(
					'@/views/home/platformManagement/ExcelSealEdit/Excel')
			},
			{
				path: str+'/SmallProgram',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '小程序管理',
					title: '小程序管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'SmallProgram',
				component: () => import(
					'@/views/home/platformManagement/weixin/SmallProgram')
			},
			{
				path: str+'/whiteList',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '白名单',
					title: '白名单管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'whiteList',
				component: () => import(
					'@/views/home/platformManagement/whiteList/whiteList')
			},
			{
				path: str+'/paymentList',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '缴费配置管理',
					title: '缴费配置管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'paymentList',
				component: () => import(
					'@/views/home/platformManagement/paymentManagement/paymentList')
			},
			{
				path:str+ '/functionalModule',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + 'APP模块管理',
					title: 'APP模块管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'functionalModule',
				component: () => import(
					'@/views/home/platformManagement/app/functionalModule/functionalModule')
			},
			{
				path: str+'/updateCenter',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + 'APP升级中心',
					title: 'APP升级中心',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'updateCenter',
				component: () => import(
					'@/views/home/platformManagement/app/updateCenter/updateCenter')
			},
			{
				path: str+'/printingConfig',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '印控台配置',
					title: '印控台配置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'printingConfig',
				component: () => import(
					'@/views/home/platformManagement/printingConfig/printingConfig')
			},
			{
				path:str+ '/systemProp',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '系统属性配置',
					title: '系统属性配置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'systemProp',
				component: () => import(
					'@/views/home/platformManagement/systemProp/systemProp')
			},
			{
				path:str+ '/applicationManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '应用管理',
					title: '应用管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'applicationManagement',
				component: () => import(
					'@/views/home/platformManagement/applicationManagement/applicationManagement')
			},
			{
				path:str+ '/templateManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + '模板管理',
					title: '模板管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'templateManagement',
				component: () => import(
					'@/views/home/platformManagement/templateManagement/templateManagement')
			},
			]
		},
		{
			path: str+'/dataManagement',
			redirect:str+'/applicationChapter',
			meta: {
				key: 2,
				networkTitle: title + '审批管理',
				title: '审批管理',
			},
			name: 'dataManagement',
			component: () => import('@/views/home/dataManagement/dataManagement'),
			children: [
				{
					path: str+'/applicationChapter',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '申请用章',
						title: '申请用章',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: true
					},
					name: 'applicationChapter',
					component: () => import(
						'@/views/home/dataManagement/applicationChapter/applicationChapter'
					)
				},
				{
					path:str+ '/approvalProcessing',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '审批管理',
						title: '审批处理',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'approvalProcessing',
					component: () => import(
						'@/views/home/dataManagement/approvalProcessing/approvalProcessing'
					)
				},
				{
					path: str+'/authorizationManagement',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '授权处理',
						title: '授权处理',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'authorizationManagement',
					component: () => import(
						'@/views/home/dataManagement/authorizationManagement/authorizationManagement'
					)
				},
				{
					path: str+'/auditProcessing',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '审计处理',
						title: '审计处理',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'auditProcessing',
					component: () => import(
						'@/views/home/dataManagement/auditProcessing/auditProcessing')
				},
				{
					path: str+'/pictureTracing',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '图片溯源',
						title: '图片溯源',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'pictureTracing',
					component: () => import(
						'@/views/home/dataManagement/pictureTracing/pictureTracing')
				},
				{
					path: str+'/usageRecord',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '使用记录',
						title: '使用记录',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'usageRecord',
					component: () => import(
						'@/views/home/dataManagement/usageRecord/usageRecord')
				},
				{
					path: str+'/ocrCompareManagement',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '智能OCR',
						title: '智能OCR',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'ocrCompareManagement',
					component: () => import(
						'@/views/home/dataManagement/ocrCompareManagement/ocrCompareManagement'
					)
				},
				{
					path: str+'/identComparison',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '识别比对',
						title: '识别比对',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'identComparison',
					component: () => import(
						'@/views/home/dataManagement/identComparison/identComparison'
					)
				},
				{
					path: str+'/archiving',
					meta: {
						key: 2,
						parent_name: '审批管理', //添加父级的名字属于印章下的
						networkTitle: title + '归档处理',
						title: '归档处理',
						requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
						keepAlive: false //缓存组件
					},
					name: 'archiving',
					component: () => import(
						'@/views/home/dataManagement/archiving/archiving'
					)
				}
			]
		},
		{
			path: str+'/dataStatistics',
			meta: {
				key: 2,
				networkTitle: title + '数据监控',
				title: '数据监控',
				parent_name: '数据统计', //添加父级的名字属于数据管理下的
				keepAlive: false //缓存组件
			},
			name: 'dataStatistics',
			component: () => import('@/views/home/dataStatistics/dataStatistics')
		},
		{
			path: str+'/graphicSearch',
			meta: {
				key: 2,
				networkTitle: title + '图文搜索',
				title: '图文搜索',
				parent_name: '数据统计', //添加父级的名字属于数据管理下的
				keepAlive: false //缓存组件
			},
			name: 'graphicSearch',
			component: () => import('@/views/home/dataStatistics/graphicSearch/graphicSearch')
		},

    {
    	path: str+'/accessControlRecord',
    	meta: {
    		key: 2,
    		networkTitle: title + '数据导出',
    		title: '门禁记录',
    		parent_name: '门禁记录', //添加父级的名字属于数据管理下的
    		keepAlive: false //缓存组件
    	},
    	name: 'accessControlRecord',
    	component: () => import('@/views/home/dataStatistics/accessControlRecord/accessControlRecord')
    },
		{
			path: str+'/dataExport',
			meta: {
				key: 2,
				networkTitle: title + '数据导出',
				title: '数据导出',
				parent_name: '数据导出', //添加父级的名字属于数据管理下的
				keepAlive: false //缓存组件
			},
			name: 'dataExport',
			component: () => import('@/views/home/dataExport/dataExport')
		},
		{
			path: str+'/quantumLab',
			meta: {
				key: 2,
				networkTitle: title + '量子实验室',
				title: '量子实验室',
				keepAlive: false //缓存组件
			},
			redirect:str+'/quantumStatistics',
			name: 'quantumLab',
			component: () => import('@/views/home/quantumLab/quantumLab'),
			children: [{
				path: str+'/quantumStatistics',
				meta: {
					key: 2,
					parent_name: '量子实验室', //添加父级的名字属于印章下的
					networkTitle: title + '量子监控',
					title: '量子监控',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'quantumStatistics',
				component: () => import(
					'@/views/home/quantumLab/quantumStatistics/quantumStatistics')
			}]
		},
		{
			path:str+ '/monitoringSystem',
			meta: {
				key: 2,
				networkTitle: title + '设配监控系统',
				title: '设配监控系统',
				keepAlive: false //缓存组件
			},
			name: 'monitoringSystem',
			component: () => import('@/views/home/monitoringSystem/monitoringSystem'),
			children: [{
				path: str+'/equipmentMonitoring',
				meta: {
					key: 2,
					parent_name: '设配监控系统', //添加父级的名字属于印章下的
					networkTitle: title + '设备监控',
					title: '设备监控',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'equipmentMonitoring',
				component: () => import(
					'@/views/home/monitoringSystem/equipmentMonitoring/equipmentMonitoring'
				)
			}]
		},
		{
			path: str+'/manage_company',
			meta: {
				key: 2,
				networkTitle: title + '系统管理',
				title: '系统管理',
				keepAlive: false //缓存组件
			},
			name: 'manage_company',
			component: () => import('@/views/home/manage_company/manage_company'),
			children: [{
				path:str+ '/configurationManagement',
				meta: {
					key: 2,
					parent_name: '系统管理', //添加父级的名字属于印章下的
					networkTitle: title + '配置管理',
					title: '配置管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'configurationManagement',
				component: () => import(
					'@/views/home/manage_company/configurationManagement/configurationManagement'
				)
			},
			{
				path: str+'/process_manage',
				meta: {
					key: 2,
					parent_name: '系统管理', //添加父级的名字属于印章下的
					networkTitle: title + '流程管理',
					title: '流程管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'process_manage',
				component: () => import(
					'@/views/home/manage_company/process_manage/process_manage')
			},
			{
				path:str+ '/processSetting',
				meta: {
					key: 2,
					parent_name: '系统管理', //添加父级的名字属于印章下的
					networkTitle: title + '流程设置',
					title: '流程设置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'processSetting',
				component: () => import(
					'@/views/home/manage_company/processSetting/processSetting')
			},
			{
				path:str+ '/message_manage',
				meta: {
					key: 2,
					parent_name: '系统管理', //添加父级的名字属于印章下的
					networkTitle: title + '通知管理',
					title: '通知管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'message_manage',
				component: () => import(
					'@/views/home/manage_company/message_manage/message_manage')
			},
      {
      	path:str+ '/alarmManagement',
      	meta: {
      		key: 2,
      		parent_name: '系统管理', //添加父级的名字属于印章下的
      		networkTitle: title + '关键字管理',
      		title: '关键字管理',
      		requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
      		keepAlive: false //缓存组件
      	},
      	name: 'alarmManagement',
      	component: () => import(
      		'@/views/home/manage_company/alarmManagement/alarmManagement')
      },
			{
				path:str+ '/applicationType',
				meta: {
					key: 2,
					parent_name: '申请类型', //添加父级的名字属于印章下的
					networkTitle: title + '申请类型',
					title: '申请类型',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'applicationType',
				component: () => import(
					'@/views/home/manage_company/applicationType/applicationType')
			}
			]
		},
		{
			path:str+ '/securityPolicy',
			meta: {
				key: 2,
				networkTitle: title + '安全策略',
				title: '安全策略',
				keepAlive: false //缓存组件
			},
			name: 'securityPolicy',
			component: () => import('@/views/home/securityPolicy/securityPolicy'),
			children: [{
				path:str+ '/ocrManagement',
				meta: {
					key: 2,
					parent_name: '平台管理', //添加父级的名字属于印章下的
					networkTitle: title + 'OCR管理',
					title: 'OCR管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'ocrManagement',
				component: () => import(
					'@/views/home/platformManagement/ocrManagement/ocrManagement')
			},
			{
				path: str+'/passwordRules',
				meta: {
					key: 2,
					parent_name: '安全策略', //添加父级的名字属于印章下的
					networkTitle: title + '密码规则',
					title: '密码规则',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'passwordRules',
				component: () => import(
					'@/views/home/securityPolicy/passwordRules/passwordRules')
			},
			{
				path:str+ '/threshold',
				meta: {
					key: 2,
					parent_name: '安全策略', //添加父级的名字属于印章下的
					networkTitle: title + '阈值设置',
					title: '阈值设置',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'threshold',
				component: () => import(
					'@/views/home/securityPolicy/threshold/threshold')
			}, {
				path:str+ '/remoteControl',
				meta: {
					key: 2,
					parent_name: '安全策略', //添加父级的名字属于印章下的
					networkTitle: title + '远程控制',
					title: '远程控制',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'remoteControl',
				component: () => import(
					'@/views/home/securityPolicy/remoteControl/remoteControl')
			},
			]
		},
		{
			path:str+ '/electronicSeal',
			redirect:str+'/electronicManagement',
			meta: {
				key: 2,
				networkTitle: title + '电子印签',
				title: '电子印签',
				keepAlive: false //缓存组件
			},
			component: () => import('@/views/home/electronicSeal/electronicSeal'),
			children: [{
				path: str+'/electronicManagement',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '电子印签管理',
					title: '电子印签管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
					keepAlive: false //缓存组件
				},
				name: 'electronicManagement',
				component: () => import(
					'@/views/home/electronicSeal/electronicManagement/electronicManagement'
				)
			},
			{
				path:str+ '/certificationcenter',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '实名认证',
					title: '实名认证',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'certificationcenter',
				component: () => import(
					'@/views/home/electronicSeal/certificationcenter/certificationcenter'
				)
			},
			{
				path: str+'/templateManagement',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '模板管理',
					title: '模板管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'templateManagement',
				component: () => import(
					'@/views/home/electronicSeal/templateManagement/templateManagement'
				)
			},
			{
				path: str+'/createContract',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '创建合同',
					title: '创建合同',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'createContract',
				component: () => import(
					'@/views/home/electronicSeal/createContract/createContract')
			},
			{
				path: str+'/createTemplate',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '创建模板',
					title: '创建模板',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'createTemplate',
				component: () => import(
					'@/views/home/electronicSeal/createTemplate/createTemplate')
			},
			{
				path: str+'/contractManagement',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '合同管理',
					title: '合同管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'contractManagement',
				component: () => import(
					'@/views/home/electronicSeal/contractManagement/contractManagement')
			},
			{
				path: str+'/signManagement',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '签署方管理',
					title: '签署方管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'signManagement',
				component: () => import(
					'@/views/home/electronicSeal/signManagement/signManagement')
			},
			{
				path: str+'/transactorManagement',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '印章管理员',
					title: '印章管理员',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'transactorManagement',
				component: () => import(
					'@/views/home/electronicSeal/transactorManagement/transactorManagement')
			},
			{
				path:str+ '/signTimeManagement',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '签约次数管理',
					title: '签约次数管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'signTimeManagement',
				component: () => import(
					'@/views/home/electronicSeal/signTimeManagement/signTimeManagement')
			},
			{
				path: str+'/CAcertificate',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + 'CA证书管理',
					title: 'CA证书管理',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'CAcertificate',
				component: () => import(
					'@/views/home/electronicSeal/CAcertificate/CAcertificate')
			},
			{
				path: str+'/electroUsageRecord',
				meta: {
					key: 2,
					parent_name: '电子印签',
					networkTitle: title + '使用记录',
					title: '使用记录',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'electroUsageRecord',
				component: () => import(
					'@/views/home/electronicSeal/usageRecord/usageRecord')
			},

			],

		},
		{
			path:str+ '/sealCabinet',
			redirect:str+'/sealCabinetList',
			component: () => import('@/views/home/sealCabinet/sealCabinet'),
			children: [{
				path: str+'/sealCabinetList',
				meta: {
					parent_name: '印章柜',
					networkTitle: title + '印章柜管理',
					title: '印章柜列表',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'sealCabinetList',
				component: () => import(
					'@/views/home/sealCabinet/sealCabinetList/sealCabinetList')
			},{
				path: str+'/sealInCabinet',
				meta: {
					parent_name: '印章柜',
					networkTitle: title + '印章柜管理',
					title: '印章入柜',
					requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
				},
				name: 'sealInCabinet',
				component: () => import(
					'@/views/home/sealCabinet/sealInCabinet/sealInCabinet')
			},{
        path: str+'/accessRecord',
        meta: {
          parent_name: '印章柜',
          networkTitle: title + '印章柜管理',
          title: '存取记录',
          requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        },
        name: 'accessRecord',
        component: () => import(
          '@/views/home/sealCabinet/accessRecord/accessRecord')
    },
    {
        path: str+'/inventoryRecord',
        meta: {
          parent_name: '印章柜',
          networkTitle: title + '印章柜管理',
          title: '盘存记录',
          requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        },
        name: 'inventoryRecord',
        component: () => import(
          '@/views/home/sealCabinet/inventoryRecord/inventoryRecord')


    },
    {
        path: str+'/cabinetMonitoring',
        meta: {
          parent_name: '印章柜',
          networkTitle: title + '印章柜管理',
          title: '柜体监控',
          requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
        },
        name: 'cabinetMonitoring',
        component: () => import(
          '@/views/home/sealCabinet/cabinetMonitoring/cabinetMonitoring')


    },],

		},
		]
	},
	{
		path: str+'/login',
		name: 'login',
		meta: {
			key: 1,
			networkTitle: title + '登录',
			title: '登录',
		},
		component: () => import('@/views/login-yx/index')
	},
	{
		path: str+'/exportUseRecord',
		name: 'exportUseRecord',
		meta: {
			key: 1,
			networkTitle: title + '申请导出',
			title: '申请导出',
		},
		component: () => import('@/views/home/dataManagement/exportUseRecord/exportUseRecord')
	},
	{
		path: str+'/applyForExport',
		name: 'applyForExport',
		meta: {
			key: 1,
			networkTitle: title + '申请导出',
			title: '申请导出',
		},
		component: () => import('@/components/applyForExport/applyForExport')
	},
	{
		path: str+'/regist',
		name: 'regist',
		meta: {
			key: 1,
			title: '注册',
			networkTitle: title + '注册',
		},
		component: () => import('@/views/regist-yx/regist')
	},
	{
		path: str+'/regist_org',
		name: 'regist_org',
		meta: {
			key: 1,
			title: '公司注册',
			networkTitle: title + '公司注册',
		},
		component: () => import('@/views/regist-yx/regist_org')
	},
	{
		path: str+'/resetPwd',
		name: 'resetPwd',
		meta: {
			key: 1,
			title: '重置密码',
			networkTitle: title + '重置密码',
		},
		component: () => import('@/views/regist-yx/resetPwd')
	},
	{
		path: str+'/agreement',
		meta: {
			key: 2,
			parent_name: '平台管理', //添加父级的名字属于印章下的
			networkTitle: title + '用户协议和隐私政策',
			title: '用户协议和隐私政策',
			requireAuth: true, // 添加该字段，表示进入这个路由是需要登录的
			keepAlive: false //缓存组件
		},
		name: 'agreement',
		component: () => import('@/views/agreement/agreement')
	},
	{
		path: str+'/404',
		meta: {
			key: 2,
			parent_name: '平台管理', //添加父级的名字属于印章下的
			networkTitle: title + '错误页面',
			title: '错误页面'
		},
		name: '404',
		component: () => import('@/views/errorPage/404')
	},
	{
		path: str+'/jumpApplicationInfo',
		meta: {
			key: 2,
			parent_name: '平台管理', //添加父级的名字属于印章下的
			networkTitle: title + '申请单详情',
			title: '申请单详情'
		},
		name: 'jumpApplicationInfo',
		component: () => import('@/views/jump/applicationInfo/applicationInfo')
	},
	{
		path: str+'/jumpDeviceList',
		meta: {
			key: 2,
			parent_name: '平台管理', //添加父级的名字属于印章下的
			networkTitle: title + '设备列表',
			title: '设备列表'
		},
		name: 'jumpDeviceList',
		component: () => import('@/views/jump/deviceList/deviceList')
	},
	{
		path: str+'/login4a',
		meta: {
			key: 2,
			parent_name: '平台管理', //添加父级的名字属于印章下的
			networkTitle: title + '登录页面',
			title: '登录页面'
		},
		name: 'login4a',
		component: () => import('@/views/jump/login4a')
	},
	{
		path: str+'/jumpLogin',
		meta: {
			key: 2,
			parent_name: '平台管理', //添加父级的名字属于印章下的
			networkTitle: title + '登录',
			title: '登录'
		},
		name: 'jumpLogin',
		component: () => import('@/views/jump/login/index')
	}
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js